import React from 'react'
import TablePagination from 'components/pagination/table-pagination'

export default function StudentsTablePagination(props) {
  return <TablePagination alwaysShowCount {...props} />
}
